module.exports = __webpack_public_path__ + "img/racecourse-turffontein-turf-inner-2200.72976cb2.svg";